import Vue from "vue";
import Vuex, { ModuleTree } from "vuex";
import { BootstrapConfig } from "shared/bootstrap";

Vue.use(Vuex);

let initialState = "";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const state: { [key: string]: any } = {};

const store = new Vuex.Store({
  state,
  mutations: {
    storeInitialState(s): void {
      initialState = JSON.stringify(s);
    },
    loadInitialState(s): void {
      const initial = JSON.parse(initialState);
      Object.keys(initial).forEach((key): void => {
        s[key] = initial[key];
      });
    }
  }
});

export default store;

export const preloadStores = (config: BootstrapConfig): void => {
  store.commit("storeInitialState");
  store.commit("auth/setStateFromLocalStorage");
  store.dispatch("auth/keepLoggedInSynced");
  store.commit("global/setLoginBackground", config.loginBackground);
  store.commit("global/setBranded", config.branding);
  store.commit("global/setApplicationName", config.title);
};

export const loadModules = (modules: ModuleTree<{}>): void => {
  const keys = Object.keys(modules);
  keys.forEach((key): void => {
    store.registerModule(key, modules[key]);
  });
};
